import { render, staticRenderFns } from "./ListConfirmReceiveParcel.vue?vue&type=template&id=3b5af629&scoped=true"
import script from "./ListConfirmReceiveParcel.vue?vue&type=script&lang=js"
export * from "./ListConfirmReceiveParcel.vue?vue&type=script&lang=js"
import style0 from "./ListConfirmReceiveParcel.vue?vue&type=style&index=0&id=3b5af629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5af629",
  null
  
)

export default component.exports